
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"254.007","height":"68.816"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_48605","data-name":"Group 48605","transform":"translate(-431.853 -284.422)"}},[_c('g',{attrs:{"id":"Group_48587","data-name":"Group 48587","transform":"translate(471 292.25)","opacity":".358","fill":"#8787e2","stroke":"#8787e2","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"4"}},[_c('path',{attrs:{"id":"Path_38014","data-name":"Path 38014","d":"M17.6 12.548l-4.3-4.3m0 0l-4.3 4.3m4.3-4.3v10.747","transform":"translate(194.435 19.045)","opacity":".6"}}),_c('path',{attrs:{"id":"Path_38016","data-name":"Path 38016","d":"M17.6 12.548l-4.3-4.3m0 0l-4.3 4.3m4.3-4.3v10.747","transform":"translate(101.314 -2.229)","opacity":".331"}}),_c('path',{attrs:{"id":"Path_38017","data-name":"Path 38017","d":"M17.6 12.548l-4.3-4.3m0 0l-4.3 4.3m4.3-4.3v10.747","transform":"translate(80.314 39.993)","opacity":".331"}}),_c('path',{attrs:{"id":"Path_38010","data-name":"Path 38010","d":"M17.6 12.548l-4.3-4.3m0 0l-4.3 4.3m4.3-4.3v10.747","transform":"translate(45 -13.25)","opacity":".759"}}),_c('path',{attrs:{"id":"Path_38013","data-name":"Path 38013","d":"M17.6 12.548l-4.3-4.3m0 0l-4.3 4.3m4.3-4.3v10.747","transform":"translate(-45.319 2.495)","opacity":".67"}})])])])
          )
        }
      }
    